import React from 'react';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';

const FilterTags = ({ facetFilters }) => {
    const dispatch = useDispatch();

    const selectedFacetGroup = facetFilters.filter(
        (filter) => filter.selectedOptions.length > 0
    );

    const optionLabel = (group, optionId) => {
        const option = group.options.find((o) => o.id === optionId);
        return option ? option.label : optionId;
    };

    return selectedFacetGroup.length === 0 ? null : (
        <div className="selected-filter">
            {selectedFacetGroup.map((group, index) => (
                <span
                    className="selected-filter__tag"
                    onClick={(event) => dispatch(searchFacetChange(group))}
                    key={`group-${index}`}
                >
                    {group.label}:{' '}
                    {group.selectedOptions.map((optionId) => (
                        <span key={optionId}>
                            {optionLabel(group, optionId)}
                        </span>
                    ))}
                </span>
            ))}
        </div>
    );
};

export default FilterTags;
